/** @jsxImportSource @emotion/react */

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useState } from 'react'

import { bindActionToPromise } from '@sportninja/common/actions/utils'
import authActions from '@sportninja/common/actions/auth'
import userActions from '@sportninja/common/actions/user'

import UserSettingsModal from '../UserSettingsModal'

import { getSelfUser } from '@sportninja/common/selectors/users'

const AccountSettings = ({
  button,
  changePassword,
  user,
  logout,
  fetchMe,
  // Optional (see propTypes): run after the profile save refreshes Redux. Lets a
  // host (e.g. the Profile page, which renders from its own reducer rather than
  // Redux) refresh its copy too. Other mount sites (MainNav) omit it.
  onProfileUpdated: onProfileUpdatedProp,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleProfileUpdated = async () => {
    await fetchMe()
    await onProfileUpdatedProp?.()
  }

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handlePasswordChange = async (values) => {
    const response = await changePassword(values)
    return response
  }

  return (
    <>
      {button({ onClick: handleOpenModal })}
      <UserSettingsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onPasswordChange={handlePasswordChange}
        userEmail={user?.email}
        userId={user?.id}
        userName={user?.fullName}
        userImageId={user?.imageId}
        onLogout={logout}
        onProfileUpdated={handleProfileUpdated}
      />
    </>
  )
}

AccountSettings.propTypes = {
  button: PropTypes.func.isRequired,
  changePassword: PropTypes.func.isRequired,
  // Optional — only the Profile page passes it (see the destructure above).
  onProfileUpdated: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    user: getSelfUser(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changePassword: bindActionToPromise(dispatch, authActions.change.request),
    logout: bindActionToPromise(dispatch, authActions.logout.request),
    fetchMe: () => dispatch(userActions.read.request(null, null)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountSettings)
